function getCSSTransitionDuration({ element, ms = false }) {
  return (
    parseFloat(window.getComputedStyle(element).transitionDuration) *
    (ms ? 1000 : 1)
  );
}

function getSlideshows() {
  // Get slideshow els
  const slideshows = document.querySelectorAll('.slideshow');
  return slideshows;
}

function slideLeave(slide) {
  slide.classList.add('leaving');

  // Get transition duration
  const tsDuration = getCSSTransitionDuration({
    element: slide,
    ms: true,
  });
  setTimeout(function () {
    slide.classList.remove('leaving');
  }, tsDuration);
}

function setupSlideshows() {
  const slideshows = getSlideshows();

  // Set up for each slideshow
  for (let i = 0; i < slideshows.length; i++) {
    const slideshow = slideshows[i];
    const slideDelay = slideshow.dataset.slideDelay
      ? parseInt(slideshow.dataset.slideDelay)
      : 5000;

    // Get all slides
    const slides = slideshow.querySelectorAll('.slideshow__item');

    // only run if there's more than 1 slide
    if (slides.length > 1) {
      setInterval(function () {
        // find visible slide
        for (let j = 0; j < slides.length; j++) {
          const slide = slides[j];

          if (slide.matches('.visible')) {
            const currentSlide = slide;
            let nextSlide = null;

            // Get the next slide (or loop back to start)
            if (slides[j + 1]) {
              nextSlide = slides[j + 1];
            } else {
              nextSlide = slides[0];
            }

            // If found nextSlide
            if (nextSlide) {
              // Change visibility to next slide
              currentSlide.classList.remove('visible');
              slideLeave(currentSlide);
              nextSlide.classList.add('visible');

              break; // stop looping, wait for the next interval
            }
          }
        }
      }, slideDelay);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setupSlideshows();
});
